import React, { Component } from "react";
import { withRouter } from "react-router";
import Container from "../controls/Container";
import CircularLoader from "../controls/loader/CircularLoader";
import Message from "../controls/Message";
import api from "../../api";

class Users extends Component {
  state = {
    users: [],
    isLoading: false,
    showMessage: false,
    message: "",
    isError: false
  };

  async componentDidMount() {
    await this.fetchUsers();
  }

  fetchUsers = async () => {
    try {
      this.setState({ isLoading: true });

      const res = await api.user.fetchByPages();

      this.setState({
        users: res.data || [],
        isLoading: false
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        showMessage: true,
        message: error.message,
        isError: true
      });
    }
  };

  onAddClick = () => {
    this.props.history.push("/users/new");
  };

  onEditClick = id => {
    this.props.history.push(`/users/edit/${id}`);
  };

  onDeleteClick = async id => {
    if (!window.confirm("Are you sure you want to delete this staff member?")) {
      return;
    }

    try {
      await api.user.delete(id);
      await this.fetchUsers();
    } catch (error) {
      this.setState({
        showMessage: true,
        message: error.message,
        isError: true
      });
    }
  };

  onMessageCloseClick = () => {
    this.setState({
      showMessage: false,
      message: "",
      isError: false
    });
  };

  getRoleName = role => {
    if (role === 0) return "Admin";
    if (role === 2) return "Cashier";
    return "Non Admin";
  };

  render() {
    const {
      users,
      isLoading,
      showMessage,
      message,
      isError
    } = this.state;

    return (
      <Container title="Staff">
        <CircularLoader isLoading={isLoading} />

        <Message
          title="Message"
          message={message}
          show={showMessage}
          isError={isError}
          onCloseClick={this.onMessageCloseClick}
          autoClose={!isError}
        />

        <div style={{ padding: 20 }}>
          <button
            type="button"
            onClick={this.onAddClick}
            style={{
              padding: "10px 18px",
              marginBottom: 20,
              cursor: "pointer"
            }}
          >
            + Add Staff
          </button>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse"
            }}
          >
            <thead>
              <tr>
                <th style={styles.th}>Login ID</th>
                <th style={styles.th}>Name</th>
                <th style={styles.th}>Role</th>
                <th style={styles.th}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td style={styles.td}>{user.id}</td>
                  <td style={styles.td}>{user.name}</td>
                  <td style={styles.td}>{this.getRoleName(user.role)}</td>
                  <td style={styles.td}>
                    <button
                      type="button"
                      onClick={() => this.onEditClick(user.id)}
                      style={{ marginRight: 8, cursor: "pointer" }}
                    >
                      Edit
                    </button>

                    <button
                      type="button"
                      onClick={() => this.onDeleteClick(user.id)}
                      style={{ cursor: "pointer" }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}

              {users.length === 0 && !isLoading && (
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      padding: 20,
                      textAlign: "center"
                    }}
                  >
                    No staff found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Container>
    );
  }
}

const styles = {
  th: {
    textAlign: "left",
    padding: 12,
    borderBottom: "1px solid #ddd"
  },
  td: {
    padding: 12,
    borderBottom: "1px solid #eee"
  }
};

export default withRouter(Users);
